<template>
  <div id="MainBiddingDetail">
    <BiddingDetail @emitProjectDetail="callBackDataProjectDetail" />
    <ItemBidding />
    <Criteria />
    <ProjectAttachment @emitIsHaveFileTor="callBackIsHaveFileTor" />
  </div>
</template>

<script>
import BiddingDetail from "./BiddingDetail";
import ItemBidding from "./ItemBidding";
import Criteria from "./Criteria";
import ProjectAttachment from "./ProjectAttachment";
export default {
  components: {
    BiddingDetail,
    ItemBidding,
    Criteria,
    ProjectAttachment,
  },
  methods: {
    callBackDataProjectDetail(value) {
      this.$emit("emitProjectDetail", value);
    },
    callBackIsHaveFileTor(value) {
      this.$emit("emitIsHaveFileTor", value);
    },
  },
};
</script>
